import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const englishIqDeviceLandingV2Schema = z.object({
  cefr: z.string().min(2).max(2),
  expiresAt: z.number().int().nonnegative(),
  handoffToken: z.string().min(1),
  kind: z.literal('english_iq_result'),
  score: z.number().int().min(60).max(150),
  shareId: z.string().min(6).max(64),
});

const recordDeviceMatchV2ResponseDataSchema = z.object({
  landing: englishIqDeviceLandingV2Schema.nullable(),
  matched: z.boolean(),
});

export type IRecordDeviceMatchV2ResponseData = z.infer<
  typeof recordDeviceMatchV2ResponseDataSchema
>;

export const recordDeviceMatchV2ResponseSchema: z.ZodSchema<
  IAPI<IRecordDeviceMatchV2ResponseData>
> = createApiResponseSchema(recordDeviceMatchV2ResponseDataSchema) as z.ZodSchema<
  IAPI<IRecordDeviceMatchV2ResponseData>
>;

export type IRecordDeviceMatchV2Response = IAPI<IRecordDeviceMatchV2ResponseData>;
